import {
    PRESUPUESTADOR_GET_PERITAJE,
    PRESUPUESTADOR_GET_PERITAJE_DISMISS_ERROR
} from '../constants';


export function getPeritaje({ patente }, isCurrent = false, status = null, isModoVer = false, requestsId = null, isModoEditar = false) {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_GET_PERITAJE,
            data: { patente, isCurrent, status,  requestsId, isModoVer, isModoEditar }
        })
    }
}

export function dismissGetPeritajeError() {
    return {
      type: PRESUPUESTADOR_GET_PERITAJE_DISMISS_ERROR,
    }
  }